/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Paragraphs_0Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_1_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A self-contained workbook is a good evaluation case: a household budget, a small inventory, a class tracker or a personal planning sheet. You can define the expected result, inspect every important cell and keep the saved file yourself. Try the browser sample first if you want to understand the interface before installing a desktop build.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_1_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`独立的小工作簿适合用来评估，例如家庭预算、小型库存、班级记录或个人计划。你可以明确预期结果、检查重要单元格，并自行保管保存后的文件。如果想先了解界面再安装桌面版，可以先试用浏览器示例。`)
};

/**
* | output |
* | --- |
* | "A self-contained workbook is a good evaluation case: a household budget, a small inventory, a class tracker or a personal planning sheet. You can define the ..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_1_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_1_paragraphs_0(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_1_paragraphs_0(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_1_paragraphs_0 as "gc.search_guides.gridcraft_vs_excel.sections.1.paragraphs.0" }